module.exports = __webpack_public_path__ + "img/photo1.bd0754ce.png";